module.exports = __webpack_public_path__ + "static/media/info-w.73567a16.svg";